
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      window.wf.VisionCatalog ??= {};
      let d = window.wf.VisionCatalog;
      d.selectedMediaType ??= 0;
      d.selectedGenre ??= '';
      d.searchText ??= '';
      d.onlyNewReleases ??= false;
      d.loaded = false;
      return d;
    },
    beforeMount() {
      this.getCatalogJson();
    },
    methods: {
      resetFilters() {
        this.selectedMediaType = 0;
        this.selectedGenre = '';
        this.searchText = '';
      },
      getCatalogJson() {
        fetch("/webapi/visioncatalogapi/types")
          .then(response => response.json())
          .then(json => {
            this.mediatypes = json;
          });

        if (this.onlyNewReleases) {
          fetch("/webapi/visioncatalogapi/newgenres")
            .then(response => response.json())
            .then(json => {
              this.genres = json;
            });
          fetch("/webapi/visioncatalogapi/newmedia")
            .then(response => response.json())
            .then(json => {
              this.media = json;
              this.loaded = true;
            });
        } else {
          fetch("/webapi/visioncatalogapi/genres")
          .then(response => response.json())
          .then(json => {
            this.genres = json;
          });
          fetch("/webapi/visioncatalogapi/media")
            .then(response => response.json())
            .then(json => {
              this.media = json;
              this.loaded = true;
            });
        }
      },
      formatTypeNameForMobile(mediatype) {
        if (mediatype.id == 0) {
          return "All Media";
        }
        return mediatype.displayname;
      }
    },
    computed: {
      filteredMedia() {
        var tempFilteredMedia = [...this.media];
        if (this.selectedMediaType != 0) {
          tempFilteredMedia = tempFilteredMedia.filter(media => media.typeid == this.selectedMediaType);
        }
        if (this.selectedGenre !== '') {
          tempFilteredMedia = tempFilteredMedia.filter(media => media.genre.split(",").filter(g => g.trim() == this.selectedGenre).length > 0);
        }
        if (this.searchText !== '') {
          tempFilteredMedia = tempFilteredMedia.filter(media => media.displayname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
        }
        return tempFilteredMedia;
      }
    }
  }

